"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.DEFAULT = void 0;

var React = _interopRequireWildcard(require("react"));

var _antd = require("antd");

var _trashO = _interopRequireDefault(require("react-icons/lib/fa/trash-o"));

var _edit = _interopRequireDefault(require("react-icons/lib/fa/edit"));

var _externalLink = _interopRequireDefault(require("react-icons/lib/fa/external-link"));

var _videoPopover = _interopRequireDefault(require("./components/videoPopover"));

var _image = require("./components/image");

require("react-resizable/css/styles.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var DEFAULT = {
  youtube: "youtube",
  dailymotion: "dailymotion",
  youku: "youku",
  vimeo: "vimeo"
};
exports.DEFAULT = DEFAULT;

function _default(type, options) {
  var NodeComponent = function NodeComponent(_ref) {
    var props = _extends({}, _ref);

    return React.createElement(VideoNode, _extends({}, props, options, {
      type: type
    }));
  };

  return NodeComponent;
}

var VideoNode =
/*#__PURE__*/
function (_React$Component) {
  _inherits(VideoNode, _React$Component);

  function VideoNode() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, VideoNode);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(VideoNode)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      width: null,
      height: null,
      isEditing: false
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "remove", function () {
      var _this$props = _this.props,
          editor = _this$props.editor,
          node = _this$props.node;
      editor.change(function (change) {
        return change.removeNodeByKey(node.key);
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "edit", function (e) {
      e.preventDefault();

      _this.setState({
        isEditing: true
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "hidePopover", function () {
      _this.setState({
        isEditing: false
      });
    });

    return _this;
  }

  _createClass(VideoNode, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      if (this.state.isEditing && !(!nextState.isEditing && this.state.isEditing)) return false;
      return true;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          node = _this$props2.node,
          type = _this$props2.type,
          attributes = _this$props2.attributes,
          children = _this$props2.children,
          editor = _this$props2.editor,
          readOnly = _this$props2.readOnly,
          isSelected = _this$props2.isSelected,
          getId = _this$props2.getId,
          getWidth = _this$props2.getWidth,
          getHeight = _this$props2.getHeight,
          youtubeType = _this$props2.youtubeType,
          dailymotionType = _this$props2.dailymotionType,
          youkuType = _this$props2.youkuType,
          vimeoType = _this$props2.vimeoType,
          idKey = _this$props2.idKey;
      var link = "";
      var id = getId(node);
      var width = this.state.width || getWidth(node) || 560;
      var height = this.state.height || getHeight(node) || 315;
      var active = isSelected || readOnly;

      if (type === "youtube") {
        link = "https://www.youtube.com/embed/".concat(id);
      } else if (type === "dailymotion") {
        link = "https://www.dailymotion.com/embed/video/".concat(id);
      } else if (type === "vimeo") {
        link = "https://player.vimeo.com/video/".concat(id);
      } else if (type === "youku") {
        link = "https://player.youku.com/embed/".concat(id);
      }

      return React.createElement("span", attributes, React.createElement(_image.ImageNodeComponent, {
        width: width,
        height: height,
        active: active
      }, React.createElement(_image.Toolbar, {
        active: active
      }, React.createElement(_image.ToolbarItem, null, React.createElement(_antd.Tooltip, {
        title: "Open in new window"
      }, React.createElement(_externalLink.default, {
        onMouseDown: function onMouseDown(e) {
          return e.preventDefault();
        },
        onClick: function onClick() {
          var win = window.open(link, "_blank");
          win.focus();
        }
      }))), React.createElement(_image.ToolbarItem, null, React.createElement(_antd.Tooltip, {
        title: "Edit"
      }, React.createElement(_videoPopover.default, {
        youkuType: youkuType,
        youtubeType: youtubeType,
        vimeoType: vimeoType,
        dailymotionType: dailymotionType,
        idKey: idKey,
        onChange: editor.onChange,
        change: editor.state.value.change(),
        initialValue: link,
        node: node,
        width: width,
        height: height,
        hidePopover: this.hidePopover,
        isEditing: this.state.isEditing
      }, React.createElement(_edit.default, {
        onMouseDown: function onMouseDown(e) {
          return e.preventDefault();
        },
        onClick: this.edit
      })))), React.createElement(_image.ToolbarItem, null, React.createElement(_antd.Tooltip, {
        title: "Remove"
      }, React.createElement(_trashO.default, {
        onMouseDown: function onMouseDown(e) {
          return e.preventDefault();
        },
        onClick: this.remove
      })))), React.createElement(VideoLink, {
        link: link
      })), children);
    }
  }]);

  return VideoNode;
}(React.Component);

_defineProperty(VideoNode, "defaultProps", {
  youtubeType: DEFAULT.youtube,
  dailymotionType: DEFAULT.dailymotion,
  youkuType: DEFAULT.youku,
  vimeoType: DEFAULT.vimeo,
  idKey: "id"
});

var VideoLink =
/*#__PURE__*/
function (_React$Component2) {
  _inherits(VideoLink, _React$Component2);

  function VideoLink() {
    _classCallCheck(this, VideoLink);

    return _possibleConstructorReturn(this, _getPrototypeOf(VideoLink).apply(this, arguments));
  }

  _createClass(VideoLink, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      if (this.props.link === nextProps.link) return false;
      return true;
    }
  }, {
    key: "render",
    value: function render() {
      var link = this.props.link;
      return React.createElement("iframe", {
        style: {
          pointerEvents: "none"
        },
        src: link
      });
    }
  }]);

  return VideoLink;
}(React.Component);